export const getSignState = state => state.sign
